<template>
  <!-- 公司联系方法模块 -->
  <div id="contact">
    <div v-html="contInfo.info.content">
      {{contInfo.info.content}}
    </div>  
    <a href="/contact" class="call-company">联系我们</a>
  </div>
</template>
<style scoped>
#contact >>> span{
  padding: 30px 0 15px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 30px;
  display: inline-block;
  font-family: Microsoft YaHei,微软雅黑,MicrosoftJhengHei,华文细黑,STHeiti,MingLiu;
  color: #fff;
}
#contact >>> p{
  color:#fff;
}
#contact {
  width: 100;
  height: 200px;
  background-color: rgb(0, 152, 239);
  text-align: center;
}
.call-company {
  display: inline-block;
  margin-top: 15px;
  padding: 14px 30px;
  background-color: rgb(254, 210, 82);
  border-radius: 4px;
}
.call-company:hover {
  opacity: 0.9;
}
</style>
<script>
export default {
  name: "contact",
  data() {
    return {
      contInfo: {
        info: {
          content: "<p>底部文字</p>"
        }
      }
    };
  },
  mounted() {
    var self = this;
    $.ajax({
      url: "/footmanage.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data)[0];
        data.info = JSON.parse(data.info);
        console.log(data);
        self.contInfo = data;
        
      },
      error(jqXHR, status, errormsg) {}
    })
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/company_contact.vue